import React from 'react';
import BN from 'bignumber.js';
import { useSelector, useDispatch } from 'react-redux';
import ClaimBg from '../../../../../../../assets/images/gamer-claiming.png';
import Header from '../../../../../../../components/Stake/header';
import GamerWethPolygonIcon from '../../../../../../../assets/images/GAMER_WETH.png';
import * as gamerWethPolygonStakeActions from '../../../../../../../actions/gamer-weth-stake-actions-polygon';
import { formatToken } from '../../../../../../../helpers/token-helper';
import Details from '../../../../../../../components/Stake/frame/details';

const ClaimDetails = () => {
  const dispatch = useDispatch();
  const { rewardBalance, rewardEarned } = useSelector((state) => state.GAMERWETHPOLYGONStake.stake);

  const amount = formatToken(new BN(rewardBalance).plus(rewardEarned).toString(10), 10);

  const claimingToken = `${amount} GAMER`;

  const descriptions = [
    `There is an 8 day claiming period before you are able to withdraw your unclaimed tokens. Following that 8 day unclaiming period, users will be able to withdraw their rewards.`,
  ];
  return (
    <>
      <Header
        icon={GamerWethPolygonIcon}
        title='GAMER/WETH-Staking'
        onClickBack={() => dispatch(gamerWethPolygonStakeActions.stakeReset())}
      />
      <Details
        title='You Are Claiming:'
        token={claimingToken}
        buttonClick={() => dispatch(gamerWethPolygonStakeActions.claimRewardsSend(amount))}
        descriptions={descriptions}
        textButton='Claim Rewards'
        stepBg={ClaimBg}
      />
    </>
  );
};

export default ClaimDetails;
